import DailyPoster from './DailyPoster';
export default DailyPoster;
